import { useRouter } from 'next/dist/client/router'

/** We disable certain things for E2E tests to make screenshots consistent */
export const useIsInternalTesting = () => {
  return useRouter().query?.isInternalTesting === 'true'
}
